import React, { useEffect, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import SolidGauge from "highcharts/modules/solid-gauge";
HighchartsMore(Highcharts);
SolidGauge(Highcharts);
const generateIncentiveRingsData = (data) => {
  const totalRings = data.length;
  const maxRadius = 110;
  const minRadius = 50;

  const availableSpace = maxRadius - minRadius;
  const gap = totalRings > 3 ? 5 : 6;
  const totalGap = gap * (totalRings - 1);
  let thickness = (availableSpace - totalGap) / totalRings;
  const MAX_THICKNESS = 20;
  thickness = Math.min(thickness, MAX_THICKNESS);
  let outer = maxRadius;

  return data.map((item) => {
    const result = {
      ...item,
      outerRadius: `${outer}%`,
      innerRadius: `${outer - thickness}%`,
    };
    outer -= thickness + gap;
    return result;
  });
};
const mapApiToChartData = (apiData = []) => {
  const iconList = ["filter", "comments", "commenting"];

  return apiData.map((item, index) => ({
    metricname: item.metricname,
    value: item.percentage,
    goal: item.goal,
    actualvalue: item.actualvalue,
    fillcolor: item.fillcolor,
    unfillcolor: item.unfillcolor,

    // icon: iconList[index] || "circle",
    // iconColor: "#eeeeee",
  }));
};

const CustomTileChart = ({ incentiveRingsInfo = [], height = 300 }) => {
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    if (!Array.isArray(incentiveRingsInfo) || incentiveRingsInfo.length === 0)
      return null;
    const formattedData = mapApiToChartData(incentiveRingsInfo);
    const finalData = generateIncentiveRingsData(formattedData);

    const renderIcons = function () {
      const chart = this;
      if (!chart.customIconGroup) {
        chart.customIconGroup = chart.renderer
          .g("custom-icons")
          .attr({ zIndex: 3 })
          .add();
      }

      const defaultSeries = chart.series[chart.series.length - 1];
      const defaultPoint = defaultSeries.points[0];

      if (!chart.centerLabel) {
        chart.centerLabel = chart.renderer
          .text("", 0, 0, true)
          .css({
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "bold",
          })
          .attr({ zIndex: 11 })
          .add();
      }

      //  Set default center
      // if (!chart.hasInitializedCenter) {
      //   updateCenter(defaultSeries, defaultPoint);
      //   chart.hasInitializedCenter = true;
      // }
      if (!chart.hasInitializedCenter) {
        chart.centerLabel.attr({
          text: `
    <div style="text-align:center; line-height:1.2">
      <span style="display: block; font-size: 9px; font-weight: 600; color: #555; letter-spacing: 0.3px;">
        ${tileTitle}
      </span>
      <span style="display: block; font-size: 15px; font-weight: 900; color: ${color}; line-height: 1.2;">
        ${avgValue.toFixed(1)}%
      </span>
    </div>
  `,
        });

        chart.hasInitializedCenter = true;
      }
      //  ICON LOGIC - iterate through series and position icons
      chart.series.forEach((series) => {
        const point = series.points[0];
        if (!point) return;

        if (!series.icon || !series.icon.element) {
          if (series.icon) {
            series.icon.destroy();
          }

          series.icon = chart.renderer
            .text(
              `<i class="fa fa-${series.options.custom?.icon}"></i>`,
              0,
              0,
              true,
            )
            .attr({ zIndex: 10 })
            .css({
              color: series.options.custom?.iconColor || "#000",
              fontSize: "1.1em",
              pointerEvents: "none",
            })
            .add(chart.customIconGroup);
        }
        const { innerR, r } = point.shapeArgs;

        series.icon.attr({
          x: chart.chartWidth / 2 - 10,
          y: chart.plotHeight / 2 - innerR - (r - innerR) / 2 + 6,
        });

        if (point) {
          // Always clean previous events (important)
          Highcharts.removeEvent(point);

          // updating center value on mouse hover
          // Highcharts.addEvent(point, "mouseOver", function () {
          //   updateCenter(series, point);
          // });

          Highcharts.addEvent(point, "mouseOut", function () {
            chart.centerLabel.attr({
              text: `
    <div style="text-align:center; line-height:1.2">
                    <span style="display: block; font-size: 9px; font-weight: 600; color: #555; letter-spacing: 0.3px;">
                      ${tileTitle}
                    </span>
                    <span style="display: block; font-size: 15px; font-weight: 900; color: ${color}; line-height: 1.2;">
                      ${avgValue.toFixed(1)}%
                    </span>
    </div>
  `,
            });
          });
        }
      });

      //  Position center label
      const x = chart.plotLeft + chart.plotWidth / 2;
      const y = chart.plotTop + chart.plotHeight / 2;

      chart.centerLabel.attr({
        x,
        y: y + 5,
        align: "center",
      });
    };
    const avgValueRaw =
      finalData.reduce((sum, item) => sum + item.value, 0) / finalData.length;

    const avgValue = Math.min(avgValueRaw, 100);

    const tileTitle =
      Array.isArray(incentiveRingsInfo) && incentiveRingsInfo.length > 0
        ? incentiveRingsInfo[0].tileName
        : "Overall";
    const color =
      Array.isArray(incentiveRingsInfo) && incentiveRingsInfo.length > 0
        ? incentiveRingsInfo[incentiveRingsInfo.length - 1].fillcolor
        : "#3dcc6e";
    const options = {
      chart: {
        spacing: [0, 0, 0, 0],
        type: "solidgauge",
        height: height,
        animation: false,
        events: {
          render: renderIcons,
        },
      },
      tooltip: {
        backgroundColor: "#3b3b3b",
        borderWidth: 0,
        borderRadius: 6,
        shadow: false,
        followPointer: true,
        hideDelay: 100,
        outside: true,
        style: {
          color: "#fff",
          fontSize: "12px",
          fontWeight: "600",
        },
        formatter: function () {
          const actual = this.point.options.custom?.actualValue ?? this.y;

          return `${this.series.name}: ${Number(actual).toFixed(1)}%`;
        },
      },
      title: {
        text: null,
        style: {
          fontSize: "24px",
        },
      },

      pane: {
        startAngle: 0,
        endAngle: 360,
        background: finalData.map((item) => ({
          outerRadius: item.outerRadius,
          innerRadius: item.innerRadius,
          backgroundColor:
            item.unfillcolor ||
            Highcharts.color(item.fillcolor).setOpacity(0.2).get(),
          borderWidth: 0,
        })),
      },

      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: [],
      },

      plotOptions: {
        solidgauge: {
          dataLabels: { enabled: false },
          stickyTracking: true,
          animation: false,
          rounded: true,
          linecap: "round",
          states: {
            hover: {
              enabled: false,
            },
          },
        },
        series: {
          point: {
            events: {
              // mouseOver: function () {
              //   const chart = this.series.chart;

              //   if (chart.centerLabel) {
              //     chart.centerLabel.attr({
              //       text: `
              //   <div style="text-align:center">
              //     <span style="font-size:12px">${this.series.name}</span><br/>
              //     <span style="font-size:18px; color:${this.color}">
              //       ${this.y}%
              //     </span>
              //   </div>
              // `,
              //     });
              //   }
              // },
              mouseOut: function () {
                const chart = this.series.chart;
                chart.centerLabel.attr({
                  text: `
                  <div style="text-align:center; line-height:1.2">
                    <span style="display: block; font-size: 9px; font-weight: 600; color: #555; letter-spacing: 0.3px;">
                      ${tileTitle}
                    </span>
                    <span style="display: block; font-size: 15px; font-weight: 900; color: ${color}; line-height: 1.2;">
                      ${avgValue.toFixed(1)}%
                    </span>
                  </div>
                `,
                });
              },
            },
          },
          states: {
            inactive: {
              opacity: 1,
            },
            hover: {
              enabled: false,
            },
          },
        },
      },

      series: finalData.map((item, index) => ({
        name: item.metricname,
        data: [
          {
            y: item.value === 0 ? 100 : item.value,
            color:
              item.value === 0
                ? Highcharts.color(item.unfillcolor || "#ccc")
                    .setOpacity(0.01)
                    .get()
                : item.fillcolor,
            radius: item.outerRadius,
            innerRadius: item.innerRadius,
            custom: {
              actualValue: item.value,
            },
            customData: item,
          },
        ],
        rounded: item.value !== 0,
        custom: {
          icon: item.icon,
          iconColor: item.iconColor,
        },
        enableMouseTracking: true,
        zIndex: finalData.length - index,
        states: {
          hover: {
            brightness: 0,
          },
        },
      })),

      credits: { enabled: false },
      exporting: { enabled: false },
    };

    setChartOptions(options);
  }, [incentiveRingsInfo, height]);

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default CustomTileChart;
